import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { useHistory, Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import moment from 'moment';
import Modal from '@/components/Modal';
import { Flex, Box } from 'UIKit/Grid';
import { StyledButton } from 'UIKit/Form';
import { ROLE } from '@/modules/User';
import { REQUEST_REQUIRE_PAID, fetchRequirePaid } from '@/modules/Olimpic';

const RequireModal = ({ user, children, onLoad, requests, olimpic }) => {
  const history = useHistory();
  const [accessModalShow, setAccessModalShow] = useState(false);

  const paid = requests[REQUEST_REQUIRE_PAID];

  const { role, ovz, purchases } = user;

  const handleClose = () => {
    setAccessModalShow(false);
    history.push('/profile');
  };

  useEffect(() => {
    onLoad({ olimpicId: olimpic._id });
  }, []);

  useEffect(() => {
    // здесь условия скрытия контента и показа модалки об оплате
    if (role !== ROLE.LEARNER || ovz) return; // отображаем конент, если роль не ученик или юзер овз
    if (!paid?.data) return;

    const { data } = paid;

    // приоритет 9 > 6
    if (olimpic.require_9) {
      if (data.require_9) {
        setAccessModalShow(false);
      } else {
        setAccessModalShow(true);
      }
      return;
    }

    if (olimpic.require_6) {
      if (data.require_6) {
        setAccessModalShow(false);
      } else {
        setAccessModalShow(true);
      }
      return;
    }

    setAccessModalShow(false);
  }, [purchases, paid]);

  return accessModalShow &&
    (olimpic.require_9 || olimpic.require_6) &&
    moment(olimpic.start).isBefore(new Date()) ? (
    <Modal show close={handleClose}>
      <Flex flexDirection="column" alignItems="center">
        <Box mb={6} style={{ maxWidth: '500px', textAlign: 'center' }}>
          {/* <SagnificantText> */}
          <FormattedMessage
            id={
              olimpic.require_9
                ? 'REQUIRED_9_MONTHS_OLIMPIC'
                : 'REQUIRED_6_MONTHS_OLIMPIC'
            }
            defaultMessage=""
          />
          . . .{/* </SagnificantText> */}
        </Box>

        <Flex mt={9}>
          <Box mr={6}>
            <StyledButton component={Link} to="/ucoins">
              <FormattedMessage id="PURCHASES" defaultMessage="" />
            </StyledButton>
          </Box>
          <StyledButton onClick={handleClose}>
            <FormattedMessage id="CANCEL" defaultMessage="" />
          </StyledButton>
        </Flex>
      </Flex>
    </Modal>
  ) : (
    children
  );
};

RequireModal.propTypes = {
  user: PropTypes.object.isRequired,
  onLoad: PropTypes.func.isRequired,
  requests: PropTypes.object.isRequired,
  olimpic: PropTypes.object.isRequired,
  children: PropTypes.any,
};

RequireModal.defaultProps = {
  children: <></>,
};

const mapStateToProps = state => ({
  user: state.user,
  requests: state.requests,
  olimpic: state.olimpic.online,
});

const mapDispatchToProps = dispatch => ({
  onLoad(data) {
    dispatch(fetchRequirePaid(data));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(RequireModal);
